import axiosInstance from '@/utils/api.js'

var state = {
  freezedService: []
}

var getters = {
  FREEZED_SERVICE: (state) => {
    return state.freezedService
  }
}

var mutations = {
  SET_FREEZED_SERVICE: (state, payload) => {
    state.freezedService = payload
  }
}

var actions = {
  GET_FREEZED_SERVICE: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/services/freezed?service_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_FREEZED_SERVICE', result.data)
    }
  },
  CREATE_FREEZED_SERVICE: (context, payload) => {
    return axiosInstance.post('/tariffing/services/freezed', payload)
  },
  UPDATE_FREEZED_SERVICE: (context, payload) => {
    return axiosInstance.put('/tariffing/services/freezed', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/freezedServices.js